module.exports = __webpack_public_path__ + "static/media/success-message-bubble.148b2639.svg";